// extracted by css-extract-rspack-plugin
module.exports =  {"alert":"FormerJobs__alert--Ph5vL","officeName":"FormerJobs__officeName--ePBt_","primaryPanelHeader":"FormerJobs__primaryPanelHeader--IfUdd"};